module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main/logout/logout.component.html
// module id = ./src/app/main/logout/logout.component.html
// module chunks = main